/**
 * Extract value from unary matcher data.
 */
export function numericTransform(unaryNumericObject) {
    return unaryNumericObject.value;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/evaluator/matchersTransform/unaryNumeric.js
// module id = 3768
// module chunks = 25